import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/Headers/Header";
import {
  Container,
  Card,
  CardBody,
  Button,
  Row,
  Col,
  Table,
  Input,
  UncontrolledTooltip,
  Spinner,
  Modal,
  ModalBody,
} from "reactstrap";
import { Link } from "react-router-dom";
import {
  blockPlayer,
  getPlayers,
  suspendPlayer,
} from "store/actions/playerActions";
import { CSVLink } from "react-csv";
import moment from "moment";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

function Players() {
  let dispatch = useDispatch();
  const csvLink = useRef(null);
  const infoPoints = [
    "In the Athlete module, the admin can view detailed information about each athlete, including their name, ID, location, total earnings, and registration date. The admin also has the option to block an athlete and review their earnings breakdown across various features of the FHP platform.",
  ];
  const subPoints = [];
  const infoTitle = "Athletes Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [suspendedAccounts, setSuspendedAccounts] = useState([]);
  const [Id, setId] = useState("");

  const headers = [
    { label: "First Name", key: "first_name" },
    { label: "Last Name", key: "last_name" },
    { label: "Email", key: "email" },
    { label: "Registration", key: "athleteID" },
    { label: "Date of Registration", key: "time_stamps" },
    { label: "Image", key: "player_image.url" },
  ];

  let players = useSelector((state) => state.players);
  let { playerLastDocument, playerMoreData } = useSelector(
    (state) => state.players
  );
  const [loader, setLoader] = useState({
    loadMore: false,
    filter: false,
    data: false,
    clearFilter: false,
  });

  const loadMore = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getPlayers(playerLastDocument, "", () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  useEffect(() => {
    if (players.player.length == 0) {
      setLoader((prev) => ({
        ...prev,
        data: true,
      }));
      dispatch(
        getPlayers("", "", () => {
          setLoader((prev) => ({
            ...prev,
            data: false,
          }));
        })
      );
    }
  }, []);

  useEffect(() => {
    checkSuspendedAccounts();
  }, [players]);

  const checkSuspendedAccounts = () => {
    let arr = [];
    players?.player?.map((player) => {
      if (
        moment().diff(
          moment
            .unix(player.lastLoggedIn?.seconds)
            .format("DD MMM YYYY hh:mm A"),
          "years"
        ) > 4
      ) {
        arr.push(player);
      }
    });
    setSuspendedAccounts(arr);
  };
  // Table Data

  const columns = [
    "Name",
    "ID",
    "Sport",
    "State",
    "City",
    "Total Earning",
    "Created at",
  ];
  const keyMap = {
    Name: "fullName",
    ID: "athleteID",
    Sport: "sport",
    State: "state",
    City: "city",
    "Total Earning": "totalEarning",
    "Created at": "created_at",
  };
  const [switchBlockData, setSwitchBlockData] = useState({
    modal: false,
    condition: false,
    userId: "",
    loader: false,
  });
  const toggleBlockModal = () => {
    setSwitchBlockData((prev) => ({
      ...prev,
      modal: !prev.modal,
    }));
  };
  const handleSwitchBlock = () => {
    setSwitchBlockData((prev) => ({
      ...prev,
      loader: true,
    }));
    dispatch(
      blockPlayer(switchBlockData.condition, switchBlockData.userId, () => {
        setSwitchBlockData((prev) => ({
          ...prev,
          modal: false,
          condition: false,
          userId: "",
          loader: false,
        }));
      })
    );
  };
  const renderActions = (row) => (
    <>
      <UncontrolledTooltip placement="bottom" target={`block-${row.id}`}>
        Block Single Player
      </UncontrolledTooltip>
      <Button
        id={`block-${row.id}`}
        size="sm"
        onClick={(e) => {
          e.preventDefault();
          toggleBlockModal();
          setSwitchBlockData((prev) => ({
            ...prev,
            condition: !row.blocked,
            userId: row.id,
          }));
        }}
      >
        <i
          className={`fa fa-ban ${
            row.blocked ? "text-danger" : "text-primary"
          }`}
        ></i>
      </Button>
      <Link to={`players-earning/${row.id}`}>
        <Button color="primary" className="btn-sm">
          Athlete Earning
        </Button>
      </Link>
    </>
  );
  const filteredData = players.player.map((d) => ({
    ...d,
    fullName: d.first_name + " " + d.last_name,
    created_at:
      moment().diff(moment.unix(d.created_at?.seconds), "years") > 4 ? (
        <Button size="sm" color="danger">
          Registration Ended
        </Button>
      ) : (
        moment.unix(d.created_at?.seconds).format("DD MMM YYYY hh:mm A")
      ),
  }));

  const handleFilter = () => {
    setLoader((prev) => ({
      ...prev,
      filter: true,
    }));

    dispatch(
      getPlayers("", Number(Id), () => {
        setLoader((prev) => ({
          ...prev,
          filter: false,
        }));
      })
    );
  };
  const handleClear = () => {
    setLoader((prev) => ({
      ...prev,
      clearFilter: true,
    }));

    dispatch(
      getPlayers("", "", () => {
        setLoader((prev) => ({
          ...prev,
          clearFilter: false,
        }));
        setId("");
      })
    );
  };
  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row></Row>
        <div className="d-flex flex-column flex-sm-row justify-content-sm-end">
          <CSVLink
            ref={csvLink}
            headers={headers}
            filename={`FHP Athletes ${moment(new Date()).format(
              "DD-MM-YYYY"
            )}.csv`}
            data={
              players == -1 || players == "loading"
                ? []
                : players.player.map((item) => {
                    return {
                      ...item,
                      time_stamps: moment
                        .unix(item?.created_at?.seconds)
                        .format("DD-MM-YYY"),
                    };
                  })
            }
            className="btn btn-primary mr-0 mb-2 mb-sm-0 mr-sm-2"
          >
            Export Athlete
          </CSVLink>
          <Button
            color="danger"
            className="mr-0 mr-sm-2 ml-0 ml-sm-2 mb-2 mb-sm-0"
            disabled={suspendedAccounts.length == 0}
            onClick={() => {
              players.player &&
                players.player.forEach((player) => {
                  if (
                    moment().diff(
                      moment
                        .unix(player.lastLoggedIn?.seconds)
                        .format("DD MMM YYYY hh:mm A"),
                      "years"
                    ) > 6
                  ) {
                    dispatch(suspendPlayer(true, player.id));
                  }
                });
            }}
          >
            Suspend Old Accounts
          </Button>
          <h2
            className="mb-0 mt-1 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </div>

        <Row className="mt-1 mt-sm-3">
          <Col>
            <Card className="filter-card">
              <CardBody className="custom-card-body">
                <Row className="mt-1">
                  <Col xs={12} sm={6} md={4}>
                    <Input
                      value={Id}
                      name="ID"
                      onChange={(e) => setId(e.target.value)}
                      type="text"
                      placeholder="Search By ID"
                      className="mt-2 mt-sm-0 custom-filter-input"
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    md={8}
                    className="d-flex justify-content-center justify-content-sm-end align-items-center mt-2 mt-sm-0"
                  >
                    <Button
                      color="danger"
                      size="sm"
                      onClick={handleClear}
                      disabled={
                        loader.clearFilter || players.player.length == 0
                      }
                      className="me-sm-2"
                    >
                      {loader.clearFilter ? (
                        <Spinner size="sm" />
                      ) : (
                        "Clear Filter"
                      )}
                    </Button>
                    <Button
                      color="primary"
                      onClick={handleFilter}
                      disabled={loader.filter || players.player.length == 0}
                      size="sm"
                    >
                      {loader.filter ? <Spinner size="sm" /> : "Apply Filter"}
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {loader.data ? (
          <div className="text-center mt-5">
            <Spinner color="primary" />
          </div>
        ) : players.player.length == 0 ? (
          <Card className="filter-card mt-4">
            <CardBody className="bg-danger text-center rounded">
              <h2 className="text-white">
                <i className="fa fa-exclamation-triangle mr-3"></i> No Player
                Found
              </h2>
            </CardBody>
          </Card>
        ) : (
          <>
            <Card className="p-2 mt-4">
              <TableComponent
                columns={columns}
                data={filteredData}
                keyMap={keyMap}
                renderActions={renderActions}
              />
              {players.player.length > 4 && (
                <div className="text-center py-4">
                  <Button
                    className=""
                    color="primary"
                    onClick={loadMore}
                    disabled={!playerMoreData || loader.loadMore}
                  >
                    {loader.loadMore ? <Spinner size="sm" /> : "Load more"}
                  </Button>
                </div>
              )}
            </Card>
          </>
        )}
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={switchBlockData.modal} centered toggle={toggleBlockModal}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to {switchBlockData.condition ? "block" : "unblock"}{" "}
              Athlete.
            </span>
            <br />
            <br />
            <br />
            <Button
              color="primary"
              onClick={handleSwitchBlock}
              disabled={switchBlockData.loader}
            >
              {switchBlockData.loader ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={toggleBlockModal}>
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Players;
